import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyTextArea from '../../../../components/inputs/MyTextArea';
import MySwitchInput from '../../../../components/inputs/MySwitchInput';

const AtenderAlerta = ({ open, onClose, refresh, data }) => {

    const submitData = async (values) => {

        const payload = {

            event_id: data.id,
            solution: values.solution,
            is_active: values.is_active,

        }

        const response = await myApi.put('/safety/hos/update', payload);

        if(response.status === 200){

            onClose();

            refresh();

            Swal.fire({
                title: 'Evento Atendido',
                icon: 'success',
                confirmButtonText: 'Aceptar',
            });

        } else {

            onClose();

            Swal.fire({
                title: 'Error',
                text: 'Ha ocurrido un error al actualizar la alerta',
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });

        }
        
    }

    return (

        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
        >

            <DialogTitle>{data?.subject}</DialogTitle>

            {/* BODY */}

            <DialogContent>

                <Formik
                    initialValues={data}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        solution: Yup.string().required('Ingresa la solucion'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {

                        submitData(values);

                    }}
                >
                {({ handleSubmit, values }) => (

                    <Form>

                        <Grid 
                            container 
                            spacing={2} 
                            marginTop={1} 
                            sx={{ 
                                maxHeight: '80vh', 
                                overflow: 'auto',
                                mb: 2,
                                mt: 2,
                                p: 2
                            }}
                        >

                            <Grid size={12}>

                                <MyTextArea
                                    name="solution"
                                    label="Describa la solucion empleada para esta alerta"
                                />

                            </Grid>

                            {
                                values?.solution && (
                                    <Grid 
                                        size={12} 
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >

                                        <MySwitchInput
                                            name="is_active"
                                            label="Cerrar Alerta"
                                        />

                                    </Grid>
                                )
                            }

                        </Grid>

                        <DialogActions
                            sx={{ justifyContent: 'space-between' }}
                        >

                            <Button 
                                type="submit" 
                                variant="contained" 
                                color="primary"
                                onClick={handleSubmit}
                            >
                                Guardar
                            </Button>

                            <Button onClick={onClose}>Cancelar</Button>

                        </DialogActions>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default AtenderAlerta